import React, { Component } from "react";
import { Link } from "react-router-dom";
import Banner from "../../../components/common/Banner";
import Header from "../../../components/common/Header";
import DepartmentSidebar from "../component/DepartmentSidebar";
import Footer from "../../../components/common/Footer";

export default class CSEPrograms extends Component {
  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner
          title="Computer Science and Engineering"
          image="banners/department-cse.jpg"
        />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Under Graduate Program</h4>
                    </div>
                  </div>
                  <table className="table">
                    <tbody>
                      <tr>
                        <th>Bachelor of Engineering</th>
                        <td>Computer Science & Engineering</td>
                      </tr>
                      <tr>
                        <th>Started in year</th>
                        <td>1981</td>
                      </tr>
                      <tr>
                        <th>Intake</th>
                        <td>300 students</td>
                      </tr>
                      <tr>
                        <th>For Admission</th>
                        <td>
                          <Link to={process.env.PUBLIC_URL + "/admission-be"}>
                            click here
                          </Link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="ttm-service-single-content-area paddingtop-2">
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Post Graduate Program</h4>
                    </div>
                  </div>
                  <table className="table">
                    <tbody>
                      <tr>
                        <th>M. Tech in</th>
                        <td>Computer Science & Engineering</td>
                      </tr>
                      <tr>
                        <th>Started in year</th>
                        <td>2008</td>
                      </tr>
                      <tr>
                        <th>Intake</th>
                        <td>18 students</td>
                      </tr>
                      <tr>
                        <th>For Admission</th>
                        <td>
                          <Link
                            to={process.env.PUBLIC_URL + "/admission-mtech"}
                          >
                            click here
                          </Link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="ttm-service-single-content-area paddingtop-2">
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Ph.D Program</h4>
                    </div>
                  </div>
                  <table className="table">
                    <tbody>
                      <tr>
                        <th>Sl No</th>
                        <th>Departments offering Ph.D Programs</th>
                        <th>Guide Name</th>
                        <th>Area</th>
                        <th>Ph.D Pursuing</th>
                        <th>No. of Vacancies</th>
                      </tr>

                      <tr>
                        <td>1</td>
                        <td>Computer Science & Engineering</td>
                        <td>Dr. Savitha S. K</td>
                        <td>
                          Digital Image Processing, Machine Learning, Data
                          Mining
                        </td>
                        <td>2</td>
                        <td>3</td>
                      </tr>

                      <tr>
                        <td>2</td>
                        <td>Computer Science & Engineering</td>
                        <td>Dr. Girija J</td>
                        <td>
                          Image Processing, Computer Networks, Machine Learning
                        </td>
                        <td>3</td>
                        <td>3</td>
                      </tr>

                      <tr>
                        <td>3</td>
                        <td>Computer Science & Engineering</td>
                        <td>Dr. D G Jyothi</td>
                        <td>Artificial Intelligence, Machine Learning</td>
                        <td>5</td>
                        <td>1</td>
                      </tr>

                      <tr>
                        <td>4</td>
                        <td>Computer Science & Engineering</td>
                        <td>Dr. M S Bhargavi</td>
                        <td>
                          Data Mining, Artificial Intelligence, Machine Learning
                        </td>
                        <td>2</td>
                        <td>4</td>
                      </tr>

                      <tr>
                        <td>5</td>
                        <td>Computer Science & Engineering</td>
                        <td>Dr. Kempanna M</td>
                        <td>Artificial Intelligence, Machine Learning</td>
                        <td>3</td>
                        <td>2</td>
                      </tr>

                      <tr>
                        <td>6</td>
                        <td>Computer Science & Engineering</td>
                        <td>Dr. T Vijay Kumar</td>
                        <td>Artificial Intelligence, Machine Learning</td>
                        <td>2</td>
                        <td>3</td>
                      </tr>

                      <tr>
                        <td>7</td>
                        <td>Computer Science & Engineering</td>
                        <td>Dr. Shivakumar B R</td>
                        <td>Artificial Intelligence, Machine Learning</td>
                        <td>2</td>
                        <td>3</td>
                      </tr>

                      <tr>
                        <td>8</td>
                        <td>Computer Science & Engineering</td>
                        <td>Dr. Shankar Gowda B N</td>
                        <td>Web Mining, Machine Learning</td>
                        <td>2</td>
                        <td>3</td>
                      </tr>

                      <tr>
                        <td>9</td>
                        <td>Computer Science & Engineering</td>
                        <td>Dr. Bhanushree K J</td>
                        <td>Image Processing</td>
                        <td>1</td>
                        <td>4</td>
                      </tr>

                      <tr>
                        <td>10</td>
                        <td>Computer Science & Engineering</td>
                        <td>Dr. Maya B S</td>
                        <td>Medical Image Processing</td>
                        <td>3</td>
                        <td>2</td>
                      </tr>

                      <tr>
                        <td>11</td>
                        <td>Computer Science & Engineering</td>
                        <td>Dr. Suneetha K R</td>
                        <td>Web Mining</td>
                        <td>1</td>
                        <td>3</td>
                      </tr>

                      <tr>
                        <td>12</td>
                        <td>Computer Science & Engineering</td>
                        <td>Dr. Harish Kumar B T</td>
                        <td>
                          Web Mining, Data Mining, Distributed Computing, AI &
                          ML
                        </td>
                        <td>3</td>
                        <td>2</td>
                      </tr>

                      <tr>
                        <td>13</td>
                        <td>Computer Science & Engineering</td>
                        <td>Dr. Hemavathi P</td>
                        <td>Wireless Sensor Networks, IoT, Machine Learning</td>
                        <td>2</td>
                        <td>4</td>
                      </tr>

                      <tr>
                        <td>14</td>
                        <td>Computer Science & Engineering</td>
                        <td>Dr. Gunavathi H S</td>
                        <td>Image Processing</td>
                        <td>2</td>
                        <td>2</td>
                      </tr>

                      <tr>
                        <th colSpan="6">
                          For Ph.D Admission:&nbsp;
                          <Link to={process.env.PUBLIC_URL + "/admission-phd"}>
                            Click here
                          </Link>
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <DepartmentSidebar department="cse" />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    );
  }
}
